export const VALID_EXPRESS_CHECKOUT_REGIONS = [
    'US',
    'EU',
    'CA',
    'UK',
    'AU',
    'NZ',
];
